module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/minus-9af11ee96250b9b5e76384153e9600d3.svg";